import React from "react";
import { connect } from "react-redux";
import CustomModal from "../../components/Modal/CustomModal";
import images from "../../utilities/images/images";
import "./BlockedtoAccessApp.scss";


const BlockedtoAccessApp = ({ blockedData }) => {
  return (
    <CustomModal
      show={blockedData?.show_popup}
      clsClass="btn-hide"
      dialogClassName="restriction-modal"
    >
      <img src={images.prohibition} className="restriction-image" />
      <div className="modal-text">{blockedData?.title} </div>
      <div className="restrict-remark"> {blockedData?.description} </div>
      <div className="restrict-table">
        <table>
          {blockedData?.dues?.map((elem,index) => (
            <tr key={index}>
              <td className="key">{elem.due_text}</td>
              <td className="value">{elem.due_value}</td>
            </tr>
          ))}
        </table>
      </div>

      {blockedData?.payment_link !== undefined &&
        blockedData?.payment_link !== null && (
          <div className="restric-paynow">
            <a
              href={blockedData?.payment_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              Pay Now
            </a>
          </div>
        )}
    </CustomModal>
  );
};

const mapStateToProps = (state) => {
  return {
    blockedData: state.BlockUserSlice.blockedData,
  };
};

export default connect(mapStateToProps, null)(BlockedtoAccessApp);
